// @flow
import i18n from 'react-native-i18n';

export default (validFrom: number, validTo: number) => {
  return i18n.t('vouchers.validFromTo', {
    from: i18n.l('date.formats.voucherDate', validFrom * 1000),
    to: i18n.l('date.formats.voucherDate', validTo * 1000),
  });
};
